import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import {
  cityValidatorRequired,
  countryValidatorRequired,
  drivingLicenseValidator,
  drivingLicenseValidatorRequired,
  emailValidatorRequired,
  nameSurnameValidatorRequired,
  peselValidatorRequired,
  phoneValidatorRequired,
  postalCodePolandValidatorRequired,
  streetHouseNumberValidatorRequired,
  streetValidatorRequired,
} from "../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.APPLICANT_DRIVER]: yup.object({
    [ComponentId.APPLICANT_DRIVER_NAME]: nameSurnameValidatorRequired,
    [ComponentId.APPLICANT_DRIVER_SURNAME]: nameSurnameValidatorRequired,
    [ComponentId.APPLICANT_DRIVER_PHONE]: phoneValidatorRequired("driverphone"),
    [ComponentId.APPLICANT_DRIVER_EMAIL]: emailValidatorRequired,
    [ComponentId.APPLICANT_DRIVER_PESEL]: yup
      .string()
      .when(ComponentId.APPLICANT_DRIVER_LACK_OF_PESEL, {
        is: (value: boolean | string) => !value,
        then: peselValidatorRequired,
      }),
    [ComponentId.APPLICANT_DRIVER_DRIVING_LICENSE]: yup
      .string()
      .when(ComponentId.APPLICANT_DRIVER_LACK_OF_PESEL, {
        is: (value: boolean | string) => !!value,
        then: drivingLicenseValidatorRequired,
      })
      .when(ComponentId.APPLICANT_DRIVER_LACK_OF_PESEL, {
        is: (value: boolean | string) => !value,
        then: drivingLicenseValidator,
      }),
    [ComponentId.APPLICANT_DRIVER_STREET]: streetValidatorRequired,
    [ComponentId.APPLICANT_DRIVER_STREET_2]: streetHouseNumberValidatorRequired,
    [ComponentId.APPLICANT_DRIVER_ZIP_CODE]: postalCodePolandValidatorRequired,
    [ComponentId.APPLICANT_DRIVER_CITY]: cityValidatorRequired,
    [ComponentId.APPLICANT_DRIVER_COUNTRY]: countryValidatorRequired,
  }),
};
